module.exports = __webpack_public_path__ + "static/media/twelveSaffron.e7e7e3e2.jpg";